module.exports = require('../manifest.json').version



//////////////////
// WEBPACK FOOTER
// ./~/youbora-adapter-videojs5/~/youboralib/src/version.js
// module id = 18
// module chunks = 0